export enum ApplicationURL {
  FRESH_DESK = "https://freshdesk.tangocare.com/",
}

export enum ApplicationRoute {
  MY_ACCOUNT = "/myAccount",
  ADMIN = "/admin",
  AGENCY_ACCESS = "/agencyAccess",
  PROVIDER_LISTING = "/providerMaterial",
  LOGOUT = "/logout",
  HOME = "/",
  TRAINING = "/training",
  CREATE_RE_AUTH = "/createReAuth",
  PROVIDER_FINDER = "/providerFinder",
  FAQS = "/faq",
  UPLOADS = "/uploads",
  REFERRAL_MANAGEMENT = "/referralManagement",
  VIDEO_PLAYER = "/videoPlayer",
  USER_REGISTRATION = "/Account/UserRegistration",
  FORGOT_PASSWORD = "/Account/ForgotPassword",
  RESET_PASSWORD = "/Account/ResetPassword",
  CHECK_ELIGIBILITY = "/checkEligibility",
  PROVIDER_LIST = "/providerListing",
  SCORECARD = "/scorecard",
  MEMBER_INFO = "/memberInfo",
  PRIOR_AUTH_WORKFLOW = "/createPriorAuth",
  RE_AUTH_MEMBER_INFO = "/reAuthMemberInfo",
  SSO_HPS = "/ssoHps",
  NOTIFICATION = "/notification",
  HPP_SSO = "/hppSso",
}

export const loggingURLArray = [
  "api/ReferralService/CreatePriorAuthorization",
  "api/ReferralService/AddPriorAuthorizationDocument",
  "api/ReferralService/CreateReAuthorization",
  "api/Ingest/ProcessPayload"
];